/**
 * MentionText
 *
 * Renders plain text with @mentions that resolve to a real user highlighted (same style as
 * comments). Used by read surfaces that show free text with mentions — e.g. the IO Note.
 * `mentionUsers` comes from TaskProvider; if it isn't loaded the text just renders plain.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useTaskContext } from '../../../../../core/components/tasks/useTaskContext';
import { matchKnownUsername } from '../../utils/task.utils';

// Split on @tokens (capturing group keeps them); the char class mirrors the backend/comment
// matchers so trailing punctuation lands outside the token.
const MENTION_RE = /(@[A-Za-z0-9._-]+)/g;

const MentionText = ({ text }) => {
  const { mentionUsers } = useTaskContext();
  if (!text) return null;

  const parts = String(text).split(MENTION_RE);
  return (
    <>
      {parts.map((part, i) => {
        // Odd indices are the captured @tokens.
        if (i % 2 === 1) {
          const afterAt = part.slice(1);
          const matched = matchKnownUsername(afterAt, mentionUsers);
          if (matched) {
            return (
              <React.Fragment key={i}>
                <span className="task-comment__mention">{`@${matched}`}</span>
                {afterAt.slice(matched.length)}
              </React.Fragment>
            );
          }
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </>
  );
};

MentionText.propTypes = {
  text: PropTypes.string,
};

MentionText.defaultProps = {
  text: '',
};

export default MentionText;
